import React, { Component } from 'react'
import {
	FormGroup, Label, FormFeedback, Button, Modal, ModalHeader, ModalBody,
	Collapse, Card, CardBody, CardHeader, Input, UncontrolledTooltip
} from 'reactstrap';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import config from '../../config';
import JSONPath from 'jsonpath';
import CanvasDraw from "react-canvas-draw";
import ImageMapper from 'react-img-mapper';
import { getMatchedAction } from '../workflow/action/workflowActionsUtils';
import { triggerAction } from '../../actions/workflow-actions';
import { addMultipleTids } from '../../actions/workflow-item';
import AutoScrollImages from './AutoScrollImages';

export default class StaticImage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			image: null,
			imageData: null,
			currentScale: 1,
			currentPan: 0,
			imageUrl: null,
			mousePos: { x: 0, y: 0 },
			savedPos: null,
			imageMap: [],
			popover: null,
			toggleModel: false,
			toggler: 'accordian-0',
			lines: [],
			focusedPoint: '',
			selected: [],
			drawMode: true,
			savedClickData: []
		}
		this.imageDiv = React.createRef();
		this.container = null;
		this.canvasA = null;
		this.toggle = this.toggle.bind(this);
		this.toggleEditModel = this.toggleEditModel.bind(this);
		//this.checkRule = this.checkRule.bind(this);
		this.toggleTab = this.toggleTab.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	handleToggler = (id) => {
		if (this.state.toggler === id) {
			this.setState({ toggler: null });
		} else {
			this.setState({ toggler: id });
		}
	}

	setFieldValue = () => {
		const { workflowData, layoutItem,
			workflow: { currentItem: { typeModel: { customClassName, customerName } } } } = this.props;
		const { itemProperties: { staticImageConfig } } = layoutItem;
		const imageHotspotField = staticImageConfig && staticImageConfig.imageHotspotField;
		const imageHotspotFieldClass = staticImageConfig && staticImageConfig.imageHotspotFieldClass;
		let modelVersion = customClassName && customClassName.replace('com.uttara.neene.proxyto.' + customerName + '_', '');
		modelVersion = modelVersion.substring(0, modelVersion.indexOf('.'));
		const iModelVerision = parseInt(modelVersion.substring(1));
		let className = imageHotspotFieldClass;
		for (let i = 0; i < iModelVerision; i++) {
			if (className.indexOf('v' + i + '.') != -1)
				className = className.replace('v' + i + '.', modelVersion + '.').replace(customerName.capitalize() + '_v' + i, customerName.capitalize() + '_' + modelVersion);
		}
		let savedLines = staticImageConfig && workflowData && staticImageConfig.imageHotspotField &&
			JSONPath.value(workflowData, `$.${staticImageConfig.imageHotspotField}`);

		let valueField = staticImageConfig && staticImageConfig.valueField;
		valueField = valueField.split(`${staticImageConfig.imageHotspotField}.`)
		let tmp = !savedLines ? [] : savedLines;
		let t = this.loadableCanvas && this.loadableCanvas.getSaveData();
		t = t && JSON.parse(t);

		const lines = t ? t.lines : [];
		if(!lines[0] || (lines[0] && lines[0].brushColor && !this.state.drawMode)){
			let first = tmp[0] && tmp[0].points;
			first = first ? JSON.parse(first) : [];
			if(first[0] && typeof first[0].x != 'undefined')
			{
				tmp = []
			}
			this.state.savedClickData.map((l, index) => {
				let obj = { class: className };
				obj[`${valueField[1]}`] = JSON.stringify(l);
				tmp.push(obj)
				
			})
		} else {
			let first = tmp[0] && tmp[0].points;
			first = first ? JSON.parse(first) : [];
			if(first[0] && typeof first[0].x == 'undefined')
			{
				tmp = []
			}
			lines.map((l, index) => {
				let obj = { class: className };
				const arr = l.points;
				const brushColor = l.brushColor.split('#');
				const f = tmp.find(t => t.id == brushColor[1]);
				if (!f) {
					obj[`${valueField[1]}`] = JSON.stringify(arr);
					tmp.push(obj)
				}
	
			})
		}
		this.props.change(`${imageHotspotField}`, tmp)
		this.setState({savedClickData: []})

	}

	toggle(area) {
		this.setState({ popover: area ? area : null })
	}

	componentDidMount() {
		const { workflow: { currentItem: { inlineAction, operation } }, container, columnIndex } = this.props;
		const colOperation = container.properties.colLayoutConfig && container.properties.colLayoutConfig[`colOperation-${columnIndex}`];
		const layoutOperation = colOperation ? colOperation : operation;
		const { staticImageConfig } = this.props.layoutItem.itemProperties;
		let imgUrl = staticImageConfig && staticImageConfig.url;
		const imageField = staticImageConfig && staticImageConfig.imageField;
		const { workflowData } = this.props;
		let mainAction = null;
		const keys = workflowData && Object.keys(workflowData);
		const additionalModelData = workflowData && workflowData['__ADDITIONAL_MODEL_DATA'];
		const k = additionalModelData ? Object.keys(additionalModelData) : [];
		let updatedAdditionalModelData = null;
		k.map(i => {
			const tmp = i.replace('_', ' ');
			if (tmp == staticImageConfig.additionalModel) {
				updatedAdditionalModelData = additionalModelData[i];
			}
		})
		if (imageField && workflowData) {
			imgUrl = ModelPropertiesParser(`{{${imageField}}}`, workflowData);
			if (keys.includes('__ADDITIONAL_MODEL_DATA')) {
				imgUrl = ModelPropertiesParser(
					`{{${imageField}}}`,
					updatedAdditionalModelData
				);
			}

			imgUrl = imgUrl && imgUrl.startsWith('http') ? imgUrl : config.assetsBasePath + imgUrl;
			let cleanedUrl = imgUrl.replace(/(?<!:)\/+/g, "/");
			imgUrl = cleanedUrl
		}
		if (staticImageConfig.isTextualActionTriggerEnabled) {
			mainAction = getMatchedAction(
				inlineAction,
				staticImageConfig.textualActionTriggerCode
			);
		}
		let { imageUrl, drawMode } = this.state;
		const textOne = staticImageConfig.textOne;
		const textTwo = staticImageConfig.textTwo;
		const payloadField = staticImageConfig.payloadField;
		let valueField = staticImageConfig && staticImageConfig.valueField;
		valueField = valueField && valueField.replace(`${staticImageConfig.imageHotspotField}.`, '')
		let lines = staticImageConfig && workflowData && staticImageConfig.imageHotspotField &&
			JSONPath.value(workflowData, `$.${staticImageConfig.imageHotspotField}`);
		if (keys && keys.includes('__ADDITIONAL_MODEL_DATA')) {
			try {
				lines = JSONPath.value(updatedAdditionalModelData, `$.${staticImageConfig.imageHotspotField}`);
			} catch(error) {
				console.log("Error while loading image", error);
			}
			
		}
		lines = !lines ? [] : lines;
		let areaMap = [];
		let savedData = { lines: [] };
		lines.map((l, index) => {
			let arr = ModelPropertiesParser(`{{${valueField}}}`, l);
			arr = arr ? JSON.parse(arr) : [];
			savedData.lines.push({ points: arr, brushColor: `#${l.id}`, brushRadius: 1 })
			let tmp = ''
			if(arr[0] && typeof arr[0].x == 'undefined')
			{
				tmp = arr;
			} else {
				const size = arr.length > 10 ? Math.ceil(arr.length / 10) : arr.length;
				tmp = Array.from({ length: size < 10 ? size : 10 }, (v, i) =>
					arr.slice(i * size, i * size + size)
				);
			}
			const t1 = textOne ? textOne.replace(`${staticImageConfig.imageHotspotField}.`, '') : null;
			const t2 = textTwo ? textTwo.replace(`${staticImageConfig.imageHotspotField}.`, '') : null;
			const pF = payloadField ? payloadField.replace(`${staticImageConfig.imageHotspotField}.`, '') : null;
			const obj = {
				"id": payloadField ? ModelPropertiesParser(`{{${pF}}}`, l) : l.id,
				"title": t1 ? ModelPropertiesParser(`{{${t1}}}`, l) : t1,
				"desc": t2 ? ModelPropertiesParser(`{{${t2}}}`, l) : t2,
				"shape": "poly",
				"fillColor": "#eab54d4d",
				"strokeColor": "black",
				"coords": [

				],
				"polygon": [

				]
			};
			tmp.map(t => {
				//obj.polygon.push([t[0].x, t[0].y])
				if(t[0]){
					t[0].x ? obj.coords.push(t[0].x) : obj.coords.push(t.split(',')[0]);
					t[0].y ? obj.coords.push(t[0].y) : obj.coords.push(t.split(',')[1])
				}
			})
			//obj.polygon.push([arr[arr.length-1].x, arr[arr.length-1].y])
			obj.coords.push(arr[arr.length - 1].x);
			obj.coords.push(arr[arr.length - 1].y);
			if (staticImageConfig.preFill) {
				obj['preFillColor'] = '#d5c39b4d';
			}

			if (mainAction) {
				const isRule = this.checkRule(mainAction.connector.rules, l);
				if (!isRule) {
					obj.fillColor = '#a5a39f4d';
					obj['inActive'] = true;
					obj['preFillColor'] = '#a5a39f4d';
				}
			}

			areaMap.push(obj)
		})

		if (layoutOperation == 'CREATEUPDATE') {
			this.clickableCanvas && this.clickableCanvas.addEventListener('click', this.handleClick, false);
		}

		if (imgUrl) {
			const image = new Image();
			image.onload = () => {
				const pH = this.imageDiv.current && this.imageDiv.current.parentElement.clientHeight;
				const pW = this.imageDiv.current && this.imageDiv.current.parentElement.clientWidth;
				let h = image.height;
				let w = image.width;
				let ratio = 0;
				if (pW && w > pW && image.width > image.height) {
					ratio = pW / w;
					h = image.height < 400 ? h : h * ratio;
					w = image.height < 400 ? w : w * ratio;
				}
				if (pH && h > pH && image.height > image.width) {
					ratio = pH / h;
					w = image.width < 400 ? w : w * ratio;
					h = image.width < 400 ? h : h * ratio;
				}
				savedData.height = h;
				savedData.width = w;
				if (!drawMode && layoutOperation == 'CREATEUPDATE' && staticImageConfig.isImageHotspot) {
					this.loadClickableCanvas(h, w, savedData, image);
				}
				if (drawMode && layoutOperation == 'CREATEUPDATE' && staticImageConfig.isImageHotspot) {
					let t = JSON.stringify(savedData)
					setTimeout(() => {
						this.loadableCanvas && this.loadableCanvas.loadSaveData(t)
					}, 500)
				}
				this.setState({ image: image, savedData: savedData, canvasH: h, canvasW: w });
			};
			image.src = imgUrl;
			imageUrl = imgUrl
		}

		this.setState({ imageUrl, imageMap: areaMap, lines: lines });
	}

		handleClick(event) {
		const { image, savedClickData } = this.state;
		const { getboundary } = this.props;
		const xRat = image.width/this.clickableCanvas.width;
		const yRat = image.height/this.clickableCanvas.height;
		const r = this.clickableCanvas.getBoundingClientRect();
		const payload = {imageUrl:this.state.imageUrl, xPoint:parseInt((event.clientX - r.left)*xRat),yPoint:parseInt((event.clientY - r.top)*yRat)};
		try{
			getboundary(payload).then(res=>{
				const data = res.data.data;
				let tmp = data.substring(8, data.indexOf('dtype')).trim().replaceAll('\n','').replaceAll('\t','').replaceAll(' ','')
					.replaceAll('[[','').replaceAll(']]','}');
					
				tmp = tmp.substring(0,tmp.length-2);
				tmp = tmp.split('},');
				console.log(tmp)
				if(tmp.length == 1){
					return;
				}
				const ctx = this.clickableCanvas.getContext("2d");

				ctx.beginPath();

				const p = tmp[0].split(',')
				ctx.moveTo(p[0]/xRat,p[1]/yRat);

				tmp.map((t,i)=>{
					if(i!=0 || i!=tmp.length-1){
						const p1 = t.split(',')
						ctx.lineTo(p1[0]/xRat,p1[1]/yRat);
					}	
				})

				ctx.lineTo(p[0]/xRat,p[1]/yRat);
				ctx.strokeStyle = "red";
				ctx.stroke();
				if(savedClickData.length == 0){
					savedClickData.push(tmp)
				} else {
					let f = false;
					savedClickData.map(d=>{
						const p = d[0].split(',');
						const p1 = tmp[0].split(',')
						if(p[0] == p1[0]){
							f = true
						}
					})
					if(!f){
						savedClickData.push(tmp)
					}
				}
			})
		} catch(e){
			console.log(e)
		}
	}

	checkRule(rules, workflowData) {
		let r = true;
		rules.forEach((x, i) => {
			//console.log(x)
			const operator = x.operator;
			const property = x.key.property;
			const staticValue = x.key.staticValue;
			const leftModelName = x.key && x.key.typeModelName;
			let value = '';
			if (staticValue) {
				value = x.key ? workflowData ? ModelPropertiesParser(staticValue, workflowData) : null : null;
			} else {
				value = x.key ? workflowData ? workflowData[property] : null : null;
			}

			switch (operator.toUpperCase()) {
				case 'NOTEQUALS':
					if (value !== x.value.staticValue) {
						r = true
					} else
						r = false;
					break;
				case 'EQUALS':
					if (value == x.value.staticValue) {
						r = true
					} else
						r = false;
					break;
			}
		})
		return r;
	}

	toggleEditModel() {
		this.setState({ toggleModel: !this.state.toggleModel })
	}

	focusCordinate(event) {
		this.setState({ focusedPoint: event.target.value })
	}

	toggleTab = () => {
		const { drawMode, canvasH, canvasW, savedData, image } = this.state;
		if (!drawMode) {
			let t = JSON.stringify(savedData)
			setTimeout(() => {
				this.loadableCanvas && this.loadableCanvas.loadSaveData(t)
			}, 500)
		} else {
			setTimeout(() => {
				this.loadClickableCanvas(canvasH, canvasW, savedData, image);
			}, 500)
		}
		this.setState({ drawMode: !drawMode })
	}

	loadClickableCanvas = (canvasH, canvasW, savedData, image) => {
		const canvas = this.clickableCanvas;
		const ctx = canvas.getContext("2d");
		canvas.width = canvasW;
		canvas.height = canvasH;
		ctx.drawImage(image, 0, 0, canvasW, canvasH);
		const xRat = image.width / canvas.width;
		const yRat = image.height / canvas.height;
		savedData.lines.map(l => {
			const tmp = l.points;
			const p = tmp[0] && !tmp[0].x && tmp[0].split(',')
			ctx.moveTo(p[0] / xRat, p[1] / yRat);

			tmp.map((t, i) => {
				if (i != 0 || i != tmp.length - 1) {
					const p1 = !t.x && t.split(',')
					ctx.lineTo(p1[0] / xRat, p1[1] / yRat);
				}
			})

			ctx.lineTo(p[0] / xRat, p[1] / yRat);
			ctx.strokeStyle = "red";
			ctx.stroke();
		})

		this.clickableCanvas && this.clickableCanvas.addEventListener('click', this.handleClick, false);
	}

	render() {
		const { staticImageConfig } = this.props.layoutItem.itemProperties;
		const { workflow, label, workflow: { currentItem: { operation, inlineAction } }, dispatch,
			workflowData, change, container, columnIndex } = this.props;
		if (!staticImageConfig) return null;
		const colOperation = container.properties.colLayoutConfig && container.properties.colLayoutConfig[`colOperation-${columnIndex}`];
		const layoutOperation = colOperation ? colOperation : operation;
		const imageURL = staticImageConfig.url;
		const isImageHotspot = staticImageConfig.isImageHotspot;
		const isAutoScroll = staticImageConfig.isAutoScroll;

		let images = [];

		images.push(staticImageConfig.url)

		for (let index = 2; index < 11; index++) {

			const imgindex = 'img' + index;
			if (staticImageConfig[imgindex]) {
				images.push(staticImageConfig[imgindex])
			}
		}
		images = images.map((image, index) => ({
			id: index + 1,
			image
		}));

		const showPopup = staticImageConfig.showPopup;
		let { imageUrl, image, imageMap, popover, lines, savedData, toggleModel, toggler, focusedPoint, drawMode } = this.state;

		const pH = this.imageDiv.current && this.imageDiv.current.parentElement.clientHeight;
		const pW = this.imageDiv.current && this.imageDiv.current.parentElement.clientWidth;
		let h = image ? image.height : 400;
		let w = image ? image.width : 400;
		let ratio = 0;
		const originalH = image && image.height;
		const originalW = image && image.width;
		if (pW && w > pW && originalW > originalH) {
			ratio = pW / w;
			h = originalH < 400 ? h : h * ratio;
			w = originalH < 400 ? w : w * ratio;
		}
		if (pH && h > pH && originalH > originalW) {
			ratio = pH / h;
			w = originalW < 400 ? w : w * ratio;
			h = originalW < 400 ? h : h * ratio;
		}
		if (isImageHotspot && layoutOperation == 'CREATEUPDATE') {

			if (toggleModel && toggler) {
				const tmp = Object.assign({}, savedData)
				const togglerId = toggler.split('-');
				tmp.lines = [];
				tmp.lines.push(savedData.lines[`${togglerId[1]}`])
				tmp.lines[0].brushRadius = 1;
				tmp.lines[0].brushColor = '#9bc2df';

				if (focusedPoint) {
					const p = focusedPoint.split(',')
					console.log(p)
					tmp.lines.push({ points: [{ x: p[0], y: p[1] }, { x: p[0], y: p[1] }], brushColor: `#e51919`, brushRadius: 3 });
					let t = JSON.stringify(tmp);
					this.disableCanvas && this.disableCanvas.loadSaveData(t)
				}
			}
			const canvasTop = this.loadableCanvas && this.loadableCanvas.canvasContainer && this.loadableCanvas.canvasContainer.offsetTop;
			const canvasLeft = this.loadableCanvas && this.loadableCanvas.canvasContainer && this.loadableCanvas.canvasContainer.offsetLeft;
			return <div ref={this.imageDiv} style={{ height: `${h}px`, width: `${w}px` }}>
				<Button onClick={this.toggleEditModel}><i className='fa fa-edit' aria-hidden="true"></i></Button>
				<Button className='ml-2' onClick={this.setFieldValue.bind(this)}>Save</Button>
				{/* <Button className='ml-1' onClick={this.toggleTab}>{drawMode ? 'Click Mode' : 'Draw Mode'}</Button> 
				<i className="fa fa-info-circle ml-1 p-1 info-icon-Li" aria-hidden="true" id='info'></i>
				<UncontrolledTooltip delay={100} className={'infoToolTip'} placement='right' target='info'>
					Previous data will be lost by switching
				</UncontrolledTooltip> */}
				{
					drawMode ? <CanvasDraw imgSrc={`${imageUrl}`} brushRadius={1}
						canvasWidth={w}
						canvasHeight={h}
						enablePanAndZoom
						clampLinesToDocument
						lazyRadius={1}
						ref={canvasDraw => (this.loadableCanvas = canvasDraw)}

					/> : <canvas ref={canvasClick => (this.clickableCanvas = canvasClick)} />
				}
				{
					toggleModel && toggler && <CanvasDraw brushRadius={1}
						canvasWidth={w}
						canvasHeight={h}
						enablePanAndZoom
						clampLinesToDocument
						lazyRadius={1}
						hideGrid={true}
						ref={canvasDraw => (this.disableCanvas = canvasDraw)}
						disabled={true}
						immediateLoading={true}
						style={{ position: 'absolute', top: `${canvasTop}px`, left: `${canvasLeft}px`, background: 'transparent' }}
					/>
				}
				<CoordsModal toggleModal={this.toggleEditModel} showModal={this.state.toggleModel}
					handleToggler={this.handleToggler.bind(this)} toggler={this.state.toggler}
					staticImageConfig={staticImageConfig} lines={lines} change={change}
					onFocusCord={this.focusCordinate.bind(this)} />
			</div>
		}
		if (isImageHotspot && layoutOperation == 'READONE') {
			let tmpMap = [];
			const xRat = image && image.width / w;
			const yRat = image && image.height / h;
			if(!drawMode)
			{
				imageMap && xRat && yRat && imageMap.map(d=>{
				let coords =[];
				d.coords.map((c,i)=>{
					if(i%2 == 0){
						coords.push(c/xRat)
					} else {
						coords.push(c/yRat)
					}
				})
				d.coords = coords;
				tmpMap.push(d)
			})
			}
			const MAP = {
				name: 'image-map',
				areas: imageMap,
			};
			const self = this;
			return <div ref={this.imageDiv} style={{ height: `${h}px`, width: `${w}px` }}>
				<ImageMapper src={imageUrl} map={MAP} width={w} height={h}
					stayMultiHighlighted={true} toggleHighlighted={true} onClick={(area, i, e) => {
						if (!staticImageConfig.allowMultiSelect && staticImageConfig.isTextualActionTriggerEnabled) {
							const mainAction = getMatchedAction(
								inlineAction,
								staticImageConfig.textualActionTriggerCode
							);
							if (mainAction && !area.inActive) {
								dispatch(triggerAction(mainAction, area.id, workflow));
							}
						}
						if (staticImageConfig.allowMultiSelect && !area.inActive) {
							let selected = self.state.selected;
							const f = selected.find(item => item == area.id);
							if (!f) {
								selected.push(area.id)
							} else {
								const index = selected.indexOf(area.id);
								selected.splice(index, 1)
							}
							self.setState({ selected })
							dispatch(addMultipleTids(selected))
						}

					}} onMouseEnter={(area, i, e) => {
						showPopup && this.toggle(area)
					}} onMouseLeave={(area, i, e) => {
						showPopup && this.toggle()
					}} />
				{
					popover && (popover.title || popover.desc) && <div className='static-text-card'
						style={{ position: 'absolute', zIndex: 99, top: `${popover.center[0]}px`, left: `${popover.center[1]}px` }}>
						<div className='primaryLine'>
							{popover.title && <h4 className='primaryLineText'>{popover.title}</h4>}
							{popover.desc && <h4 className='primaryLineText'>{popover.desc}</h4>}
						</div>
					</div>
				}
			</div>
		}
		if (isAutoScroll) {
			return (
				<AutoScrollImages images={images} speed={5000} />
			)
		}
		return (
			<div style={{ flexDirection: "column" }}>
				{
					label.show ? <Label>{label.text}</Label> : ''
				}
				<div className='staticImageDiv'>
					<img className='staticImage' src={imageURL} alt='StaticImage' />
				</div>
			</div>
		)
	}
}

const CoordsModal = (props) => {
	let lines = props.lines;
	const staticImageConfig = props.staticImageConfig;
	let valueField = staticImageConfig && staticImageConfig.valueField;
	valueField = valueField.replace(`${staticImageConfig.imageHotspotField}.`, '');
	return <div>
		<Modal isOpen={props.showModal} toggle={() => props.toggleModal()} >

			<ModalHeader toggle={props.toggleModal}>
				Edit Coordinates
			</ModalHeader>
			<ModalBody className='p-1 h-100' style={{ 'overflow': 'auto' }}>
				{
					lines && lines.map((l, index) => {
						let arr = ModelPropertiesParser(`{{${valueField}}}`, l);
						arr = JSON.parse(arr);
						return (
							<Card key={index} className="accordian">
								<CardHeader
									onClick={() => props.handleToggler(`accordian-${index}`)}>
									<i className={`icon mr-2 fa ${props.toggler === `accordian-${index}` ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
									{`${arr[0].x}, ${arr[0].y}`}
								</CardHeader>
								<Collapse className="collapse-body" isOpen={props.toggler === `accordian-${index}`}>
									<CardBody>
										{
											props.toggler === `accordian-${index}` ? arr.map(item => {
												return <div className='d-flex m-1'>
													<Input
														value={`${item.x}, ${item.y}`}
														onChange={(event) => console.log('')}
														onFocus={props.onFocusCord}
														type={'text'}
													/><i className='fa fa-trash mt-2 ml-1' style={{ 'color': 'red' }} aria-hidden="true"></i></div>
											}) : ""
										}
									</CardBody>
								</Collapse>
							</Card>
						)
					})
				}
			</ModalBody>

		</Modal>
	</div>
}
